import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import dummyImg from "../../images/no-image-thumb.jpg";

const DelayedImage = ({ src, alt, onClick, onError, delay = 0 }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setImgSrc(src);
    });

    return () => clearTimeout(timer);
  }, [src]);

  return (
    <div className="d-block w-100 list-img text-center">
      {!isLoaded && <p className="skeleton-loader"></p>}
      {imgSrc && (
        <div class="proplst-mask-container">
          <img
            src={imgSrc}
            onLoad={() => setIsLoaded(true)}
            onError={onError}
            onClick={onClick}
            className="target-image"
            alt={alt}
            style={{ display: isLoaded ? "block" : "none" }} // Hide until loaded
          />
        </div>
      )}
    </div>
  );
};

const ImageCarousel = ({ project, handleImagesModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageErrors, setImageErrors] = useState({});
  const handleImageError = (index) => {
    setImageErrors((prevErrors) => ({ ...prevErrors, [index]: true }));
  };

  if (!Array.isArray(project?.images) || project?.images.length === 0) {
    return (
      <div className="d-block w-100 list-img text-center plnoimgbox">
        <div class="proplst-mask-container">
          <img
            src={dummyImg}
            className="target-image"
            title="No Images Available"
            style={{ cursor: "no-drop" }}
          />
        </div>
      </div>
    );
  }

  return (
    <div id="customCarousel" className="carousel slide listcustomCarousel">
      {/* Indicators */}
      {project?.images?.length > 1 && (
        <div
          className="carousel-indicators"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {project.images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={index === currentIndex ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setCurrentIndex(index);
              }}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      )}

      {project?.project_rera_id !== null ? (
        <span className="rera">
          <svg
            width="68"
            height="26"
            viewBox="0 0 68 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 0H55C62.1797 0 68 5.8203 68 13C68 20.1797 62.1797 26 55 26H0V0Z"
              fill="black"
              fill-opacity="0.8"
            />
            <path
              d="M16.216 18L13.892 14.01H12.352V18H11.078V8.242H14.228C14.9653 8.242 15.586 8.368 16.09 8.62C16.6033 8.872 16.986 9.21267 17.238 9.642C17.49 10.0713 17.616 10.5613 17.616 11.112C17.616 11.784 17.42 12.3767 17.028 12.89C16.6453 13.4033 16.0667 13.744 15.292 13.912L17.742 18H16.216ZM12.352 12.988H14.228C14.9187 12.988 15.4367 12.82 15.782 12.484C16.1273 12.1387 16.3 11.6813 16.3 11.112C16.3 10.5333 16.1273 10.0853 15.782 9.768C15.446 9.45067 14.928 9.292 14.228 9.292H12.352V12.988ZM20.8696 9.278V12.54H24.4256V13.59H20.8696V16.95H24.8456V18H19.5956V8.228H24.8456V9.278H20.8696ZM31.9113 18L29.5873 14.01H28.0473V18H26.7733V8.242H29.9233C30.6606 8.242 31.2813 8.368 31.7853 8.62C32.2986 8.872 32.6813 9.21267 32.9333 9.642C33.1853 10.0713 33.3113 10.5613 33.3113 11.112C33.3113 11.784 33.1153 12.3767 32.7233 12.89C32.3406 13.4033 31.762 13.744 30.9873 13.912L33.4373 18H31.9113ZM28.0473 12.988H29.9233C30.614 12.988 31.132 12.82 31.4773 12.484C31.8226 12.1387 31.9953 11.6813 31.9953 11.112C31.9953 10.5333 31.8226 10.0853 31.4773 9.768C31.1413 9.45067 30.6233 9.292 29.9233 9.292H28.0473V12.988ZM41.0589 15.83H36.8029L36.0189 18H34.6749L38.2029 8.298H39.6729L43.1869 18H41.8429L41.0589 15.83ZM40.6949 14.794L38.9309 9.866L37.1669 14.794H40.6949Z"
              fill="white"
            />
            <g clip-path="url(#clip0_1330_4902)">
              <rect x="49" y="7" width="12" height="12" rx="6" fill="#00CC14" />
              <path
                d="M51.541 13.958L53.9993 15.9163L58.4577 10.083"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1330_4902">
                <rect
                  width="12"
                  height="12"
                  fill="white"
                  transform="translate(49 7)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      ) : (
        ""
      )}

      {/* Image Display */}
      <div className="carousel-inner">
        {project?.images?.length > 0 && (
          <div className="carousel">
            {project.images.map((image, index) => (
              <div
                key={index}
                className={`carousel-item ${
                  index === currentIndex ? "active" : ""
                }`}
              >
                {imageErrors[index] ? (
                  <div className="d-flex w-100 text-center skeleton-loader list-img">
                    <img
                      src={dummyImg}
                      className="d-block w-100 list-img"
                      style={{ display: "block" }} // Hide until loaded
                    />
                  </div>
                ) : (
                  <DelayedImage
                    src={image?.image} // Ensure correct property path
                    alt={`Slide ${index + 1}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation(); // Prevent div click
                      handleImagesModal(project);
                    }}
                    onError={() => handleImageError(index)}
                    delay={2000} // Delay before loading
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageCarousel;
